/* eslint-disable import/prefer-default-export */

// Redux actions
export const SET_VISITS = 'SET_VISITS';
export const SET_LAST_VERIFICATION_DATE = 'SET_LAST_VERIFICATION_DATE';
export const SET_VERIFICATION_ERROR = 'SET_VERIFICATION_ERROR';

export const SET_ACTIVE_PET = 'SET_ACTIVE_PET';
export const SET_ACTIVE_PET_TYPE = 'SET_ACTIVE_PET_TYPE';
export const SET_KITTEN = 'SET_KITTEN';
export const SET_SHUFFLE_PETS = 'SET_SHUFFLE_PETS';

export const SET_ALL_PETS = 'SET_ALL_PETS';

export const SET_PURCHASE_LOADING = 'SET_PURCHASE_LOADING';
export const SET_PURCHASE_SUCCESS = 'SET_PURCHASE_SUCCESS';
export const SET_PURCHASE_FAIL = 'SET_PURCHASE_FAIL';
export const CLEAR_PURCHASES = 'CLEAR_PURCHASES';

export const SET_ACTIVE_GOODY = 'SET_ACTIVE_GOODY';
export const SET_ACTIVE_GOODIES_WITH_SHUFFLE = 'SET_ACTIVE_GOODIES_WITH_SHUFFLE';
export const SET_SHUFFLE_GOODIES = 'SET_SHUFFLE_GOODIES';

export const SET_COLLECTED_GOODIES = 'SET_COLLECTED_GOODIES';
export const SET_COLLECTED_NEW_GOODIES = 'SET_COLLECTED_NEW_GOODIES';
export const SET_NEW_GOODY = 'SET_NEW_GOODY';

export const MINS_TO_VERIFY_GOOGLE = 0.01;
export const PURCHASES_NOT_SUPPORTED_FOR_COUNTRY = 'PURCHASES_NOT_SUPPORTED_FOR_COUNTRY';

// All options
export const PETS = [
	{
		sku: 'cat_tabbycat',
		type: 'cat',
		name: 'Cat',
		displayName: 'Tabby Cat',
	}, {
		sku: 'dog_lildoggo',
		type: 'dog',
		name: 'LilDoggo',
		displayName: 'Lil Doggo',
	}, {
		sku: 'penguin_tuxedobird',
		type: 'penguin',
		name: 'TuxedoBird',
		displayName: 'Tuxedo Birb',
	}, {
		sku: 'wildcat_leopard',
		type: 'wildcat',
		name: 'Leopard',
		displayName: 'Wild Kitty',
	}, {
		sku: 'bear_bear',
		type: 'bear',
		name: 'Bear',
		displayName: 'Bear Cub',
	}, {
		sku: 'turtle_tortoise',
		type: 'turtle',
		name: 'Tortoise',
		displayName: 'Happy Tortoise',
	}, {
		sku: 'dog_classicdoggo',
		type: 'classicdoggo',
		name: 'ClassicDoggo',
		displayName: 'Classic Doggo',
	}, {
		sku: 'chicken_chicken',
		type: 'chicken',
		name: 'Chicken',
		displayName: 'Chicken Birb',
	}, {
		sku: 'seal_seal',
		type: 'seal',
		name: 'Seal',
		displayName: 'Squishy Seal',
	},
	{
		sku: 'bunny_bunny',
		type: 'bunny',
		name: 'Bunny',
		displayName: 'Bunny Rabbit',
	},
	{
		sku: 'pig_pig',
		type: 'pig',
		name: 'Pig',
		displayName: 'Tubby Piglet',
	},
	// {
	// 	sku: 'wildcat_tiger',
	// 	type: 'wildcat',
	// 	name: 'Tiger',
	// },
];

export const BASE_COLLECTED_PET = {
	sku: 'cat_tabbycat',
	displayName: 'Tabby Cat',
	isCollected: true,
	petType: {
		sku: 'cat_tabbycat',
		type: 'cat',
		name: 'Cat',
	},
};

export const ALL_PETS = [
	BASE_COLLECTED_PET,
	...PETS
];

export const GOODIES = {
	'glasses-Blue': {
		id: 'glasses-Blue',
		type: 'glasses',
		name: 'Blue',
	},
	'glasses-CatEye': {
		id: 'glasses-CatEye',
		type: 'glasses',
		name: 'CatEye',
	},
	'glasses-Kerry': {
		id: 'glasses-Kerry',
		type: 'glasses',
		name: 'Kerry',
	},
	'glasses-OldMan': {
		id: 'glasses-OldMan',
		type: 'glasses',
		name: 'OldMan',
	},
	'glasses-Raybans': {
		id: 'glasses-Raybans',
		type: 'glasses',
		name: 'Raybans',
	},
	'glasses-Scuba': {
		id: 'glasses-Scuba',
		type: 'glasses',
		name: 'Scuba',
	},
	'glasses-Sunglasses': {
		id: 'glasses-Sunglasses',
		type: 'glasses',
		name: 'Sunglasses',
	},
	'glasses-ThreeD': {
		id: 'glasses-ThreeD',
		type: 'glasses',
		name: 'ThreeD',
	},
	'glasses-Aviators': {
		id: 'glasses-Aviators',
		type: 'glasses',
		name: 'Aviators',
	},
	'glasses-Heart': {
		id: 'glasses-Heart',
		type: 'glasses',
		name: 'Heart',
	},
	'glasses-Alien': {
		id: 'glasses-Alien',
		type: 'glasses',
		name: 'Alien',
	},


	'hat-Baseball': {
		id: 'hat-Baseball',
		type: 'hat',
		name: 'Baseball',
	},
	'hat-Beanie': {
		id: 'hat-Beanie',
		type: 'hat',
		name: 'Beanie',
	},
	'hat-Bow': {
		id: 'hat-Bow',
		type: 'hat',
		name: 'Bow',
	},
	'hat-Chef': {
		id: 'hat-Chef',
		type: 'hat',
		name: 'Chef',
	},
	'hat-Fedora': {
		id: 'hat-Fedora',
		type: 'hat',
		name: 'Fedora',
	},
	'hat-Fez': {
		id: 'hat-Fez',
		type: 'hat',
		name: 'Fez',
	},
	'hat-King': {
		id: 'hat-King',
		type: 'hat',
		name: 'King',
	},
	'hat-PartyHat': {
		id: 'hat-PartyHat',
		type: 'hat',
		name: 'PartyHat',
	},
	'hat-Princess': {
		id: 'hat-Princess',
		type: 'hat',
		name: 'Princess',
	},
	'hat-Spinner': {
		id: 'hat-Spinner',
		type: 'hat',
		name: 'Spinner',
	},
	'hat-Sweatband': {
		id: 'hat-Sweatband',
		type: 'hat',
		name: 'Sweatband',
	},
	'hat-Unicorn': {
		id: 'hat-Unicorn',
		type: 'hat',
		name: 'Unicorn',
	},
	'hat-Witch': {
		id: 'hat-Witch',
		type: 'hat',
		name: 'Witch',
	},
	'hat-ShrimponBarbie': {
		id: 'hat-ShrimponBarbie',
		type: 'hat',
		name: 'ShrimponBarbie',
	},
	// 'hat-FlowerCrown': {
	// 	id: 'hat-FlowerCrown',
	// 	type: 'hat',
	// 	name: 'FlowerCrown',
	// },


	'toy-BonsaiTree': {
		id: 'toy-BonsaiTree',
		type: 'toy',
		name: 'BonsaiTree',
	},
	'toy-Campfire': {
		id: 'toy-Campfire',
		type: 'toy',
		name: 'Campfire',
	},
	'toy-Coffee': {
		id: 'toy-Coffee',
		type: 'toy',
		name: 'Coffee',
	},
	'toy-Donut': {
		id: 'toy-Donut',
		type: 'toy',
		name: 'Donut',
	},
	'toy-Fishbones': {
		id: 'toy-Fishbones',
		type: 'toy',
		name: 'Fishbones',
	},
	'toy-Fishbowl': {
		id: 'toy-Fishbowl',
		type: 'toy',
		name: 'Fishbowl',
	},
	'toy-Flamingo': {
		id: 'toy-Flamingo',
		type: 'toy',
		name: 'Flamingo',
	},
	'toy-FoamFinger': {
		id: 'toy-FoamFinger',
		type: 'toy',
		name: 'FoamFinger',
	},
	'toy-IceCream': {
		id: 'toy-IceCream',
		type: 'toy',
		name: 'IceCream',
	},
	'toy-MagicWand': {
		id: 'toy-MagicWand',
		type: 'toy',
		name: 'MagicWand',
	},
	'toy-Martini': {
		id: 'toy-Martini',
		type: 'toy',
		name: 'Martini',
	},
	'toy-MiniGolf': {
		id: 'toy-MiniGolf',
		type: 'toy',
		name: 'MiniGolf',
	},
	'toy-Mouse': {
		id: 'toy-Mouse',
		type: 'toy',
		name: 'Mouse',
	},
	'toy-Pizza': {
		id: 'toy-Pizza',
		type: 'toy',
		name: 'Pizza',
	},
	'toy-Rocketship': {
		id: 'toy-Rocketship',
		type: 'toy',
		name: 'Rocketship',
	},
	'toy-SoccerBall': {
		id: 'toy-SoccerBall',
		type: 'toy',
		name: 'SoccerBall',
	},
	'toy-Synth': {
		id: 'toy-Synth',
		type: 'toy',
		name: 'Synth',
	},
	'toy-Wine': {
		id: 'toy-Wine',
		type: 'toy',
		name: 'Wine',
	},
	'toy-Yarn': {
		id: 'toy-Yarn',
		type: 'toy',
		name: 'Yarn',
	},
	'toy-Flowers': {
		id: 'toy-Flowers',
		type: 'toy',
		name: 'Flowers',
	},
	'toy-Cake': {
		id: 'toy-Cake',
		type: 'toy',
		name: 'Cake',
	},
	'toy-Dough': {
		id: 'toy-Dough',
		type: 'toy',
		name: 'Dough',
	},
	'toy-Burger': {
		id: 'toy-Burger',
		type: 'toy',
		name: 'Burger',
	},
	'toy-Cactus': {
		id: 'toy-Cactus',
		type: 'toy',
		name: 'Cactus',
	},
	'toy-RubberDuck': {
		id: 'toy-RubberDuck',
		type: 'toy',
		name: 'RubberDuck',
	},
	'toy-Egg': {
		id: 'toy-Egg',
		type: 'toy',
		name: 'Egg',
	},
	'toy-Steak': {
		id: 'toy-Steak',
		type: 'toy',
		name: 'Steak',
	},
	'toy-JazzCup': {
		id: 'toy-JazzCup',
		type: 'toy',
		name: 'JazzCup',
	},
	'toy-Gold': {
		id: 'toy-Gold',
		type: 'toy',
		name: 'Gold',
	},

	// Lil Doggo
	'toy-Bone': {
		id: 'toy-Bone',
		type: 'toy',
		name: 'Bone',
		// forPetType: 'dog',
	},

	// Bear
	'hat-Ranger': {
		id: 'hat-Ranger',
		type: 'hat',
		name: 'Ranger',
		// forPetType: 'bear',
	},

	// Penguin
	'toy-Popsicle': {
		id: 'toy-Popsicle',
		type: 'toy',
		name: 'Popsicle',
		// forPetType: 'penguin',
	},

	// Wildcat
	'toy-Sushi': {
		id: 'toy-Sushi',
		type: 'toy',
		name: 'Sushi',
		// forPetType: 'wildcat',
	},

	// turtle
	'toy-Strawberry': {
		id: 'toy-Strawberry',
		type: 'toy',
		name: 'Strawberry',
		// forPetType: 'turtle',
	},

	// Classic Doggo
	'toy-HotDog': {
		id: 'toy-HotDog',
		type: 'toy',
		name: 'HotDog',
		// forPetType: 'classicdoggo',
	},

	// Chicken
	'hat-Sombrero': {
		id: 'hat-Sombrero',
		type: 'hat',
		name: 'Sombrero',
		// forPetType: 'chicken',
	},

	// Seal
	'hat-BeachBall': {
		id: 'hat-BeachBall',
		type: 'hat',
		name: 'BeachBall',
		// forPetType: 'seal',
	},

	// Bunny
	'hat-TopHat': {
		id: 'hat-TopHat',
		type: 'hat',
		name: 'TopHat',
		// forPetType: 'bunny',
	},

	// Pig
	'toy-Money': {
		id: 'toy-Money',
		type: 'toy',
		name: 'Money',
		// forPetType: 'pig',
	},
};

// Redux states
export const INITIAL_STATES = {
	PET: {
		petType: {
			sku: 'cat_tabbycat',
			type: 'cat',
			name: 'Cat',
		},
		name: {
			first: 'Default',
			last: 'Cat',
			full: 'Default Cat',
		},
		color: 'black',
		body: 0,
		head: 0,
		likesPets: 'likes',
		toy: null,
		glasses: null,
		hat: null,
		kitten: null,
	},
};

// React stuff
export const POSITIONED_GOODY_REFS = {
	MARKER: 'MARKER',
	GOODY_CONTAINER: 'GOODY_CONTAINER',
	VIEW_BOX: 'VIEW_BOX',
};

// Initial storage state
export const INITIAL_STATE = {
	visits: 0,
	lastVerification: {},

	activePet: {
		shuffle: false,
		active: {
			petType: BASE_COLLECTED_PET.petType,
		},
	},
	allPets: [
		BASE_COLLECTED_PET,
	],
	activeGoodies: {
		shuffle: true,
		active: {},
	},
	collectedGoodies: {
		newItems: [],
		list: [],
	},
};

export const LEGACY_GOODY_MAP = {
	'hat-1': 'hat-PartyHat',
	'hat-2': 'hat-Fedora',
	'hat-3': 'hat-Fez',
	'hat-4': 'hat-Chef',
	'hat-5': 'hat-Baseball',
	'hat-6': 'hat-Beanie',
	'hat-7': 'hat-Princess',
	'hat-8': 'hat-King',
	'hat-9': 'hat-Unicorn',
	'hat-10': 'hat-Sweatband',
	'hat-11': 'hat-Spinner',
	'hat-12': 'hat-Bow',
	'glasses-1': 'glasses-Raybans',
	'glasses-2': 'glasses-CatEye',
	'glasses-3': 'glasses-ThreeD',
	'glasses-4': 'glasses-OldMan',
	'glasses-5': 'glasses-Scuba',
	'glasses-6': 'glasses-Kerry',
	'glasses-7': 'glasses-Blue',
	'glasses-8': 'glasses-Sunglasses',
	'toy-1': 'toy-Yarn',
	'toy-2': 'toy-Mouse',
	'toy-3': 'toy-Pizza',
	'toy-4': 'toy-Fishbones',
	'toy-5': 'toy-SoccerBall',
	'toy-6': 'toy-Donut',
	'toy-7': 'toy-Fishbowl',
	'toy-8': 'toy-Campfire',
	'toy-9': 'toy-MagicWand',
	'toy-10': 'toy-IceCream',
	'toy-11': 'toy-Coffee',
	'toy-12': 'toy-MiniGolf',
	'toy-13': 'toy-Flamingo',
	'toy-14': 'toy-Rocketship',
	'toy-15': 'toy-FoamFinger',
	'toy-16': 'toy-BonsaiTree',
	'toy-17': 'toy-Wine',
	'toy-18': 'toy-Synth',
	'toy-19': 'toy-Martini',
};



// WEBPACK FOOTER //
// ./src/constants/index.js